import { ReactNode } from "react";
import { View } from "react-native";
import native from "src/constants/native";
import { paddingSmall } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import Touchable from "../Touchable";

export const FLOATING_MENU_ITEM_WIDTH = 80;
const FloatingMenuButton = ({
	label,
	children,
	testID,
	onPress,
	disabled,
}: {
	label: string;
	children?: ReactNode;
	testID?: string;
	onPress?: () => void;
	disabled?: boolean;
}) => {
	return (
		<View
			testID={testID}
			style={{
				width: FLOATING_MENU_ITEM_WIDTH,
				paddingVertical: paddingSmall,
				alignItems: "center",
				justifyContent: "space-between",
			}}
			onClick={() => {
				// There's a bug on web that causes the touchable to not work after many clicks
				if (!native && !disabled) {
					onPress?.();
				}
			}}
		>
			<Touchable
				animation="None"
				onPress={native ? onPress : undefined}
				disabled={disabled}
				style={{
					alignItems: "center",
				}}
				containerStyle={{
					width: "100%",
				}}
			>
				{children}
				<Text
					semibold
					sm
					style={{
						paddingTop: paddingSmall,
					}}
				>
					{label}
				</Text>
			</Touchable>
		</View>
	);
};
export default FloatingMenuButton;
